


















import vue from "vue";
import {
  VUEX_EXERCISE_ACTION_NAMES,
  VUEX_EXERCISE_GETTER_NAMES,
  VUEX_EXERCISE_NAMESPACE
} from "@tt-app/constants";

const { NAVIGATION_CANCELLATION, NAVIGATION_CONFIRMATION } = VUEX_EXERCISE_ACTION_NAMES;
const { LOG_ID, REVIEW_PAGE } = VUEX_EXERCISE_GETTER_NAMES;

interface Methods {
  confirmNavigation: () => void;
  cancelNavigation: () => void;
}

interface Computed {
  limitedModeUpdated: false;
  logId: number;
  navigationConfirmationButtonText: string;
  open: boolean;
  reviewPage: any;
  sessionExitText: string;
}

export default vue.extend<any, Methods, Computed, any>({
  name: "ExerciseNavigationModal",

  methods: {
    confirmNavigation() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${NAVIGATION_CONFIRMATION}`);
    },

    cancelNavigation() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${NAVIGATION_CANCELLATION}`);
    }
  },

  computed: {
    limitedModeUpdated() {
      return this.$store.state.exercise.limitedModeUpdated;
    },

    logId() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${LOG_ID}`];
    },

    navigationConfirmationButtonText() {
      if (this.limitedModeUpdated) {
        return this.$__("common.ok");
      } else {
        return this.$__("ex.layout.exit-confirm.yes");
      }
    },

    open() {
      return this.$store.state.exercise.modals.navigation.open || false;
    },

    reviewPage() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${REVIEW_PAGE}`];
    },

    sessionExitText() {
      if (this.limitedModeUpdated) {
        return this.$__("tt-live.exit.confirmation");
      } else {
        return this.$__("ex.layout.exit-confirm.msg");
      }
    }
  }
});
